export default __webpack_public_path__ + "static/ethereum-hero-dark-226e59bdec53fb879018192076fa75be.mp4";